import gql from 'graphql-tag';

export const subscriptionPlanProduct = gql`
  fragment SubscriptionPlanProduct on SubscriptionPlanProduct {
    id
    name
    description
    prices {
      id
      unitAmount
      interval
    }
    workflowTier {
      type
      description
    }
    quantity
  }
`;

export const subscriptionPlan = gql`
  fragment SubscriptionPlan on SubscriptionPlan {
    name
    description
    type
    highlightPlan
    products {
      ...SubscriptionPlanProduct
    }
  }

  ${subscriptionPlanProduct}
`;
